import React from "react";
import styles from "./SwitcherTabBar.module.scss";

interface SwitcherTab {
	key: string;
	title: string;
}

interface SwitcherTabBarProps {
	tabs: SwitcherTab[];
	activeKey: string;
	onChange: (key: string) => void;
}

export const SwitcherTabBar: React.FC<SwitcherTabBarProps> = ({
	tabs,
	activeKey,
	onChange,
}) => {
	return (
		<div className={styles.wrapper}>
			{tabs.map((tab) => (
				<button
					key={tab.key}
					className={`${styles.tab} ${activeKey === tab.key ? styles.tabActive : ""}`}
					onClick={() => onChange(tab.key)}
				>
					{tab.title}
				</button>
			))}
		</div>
	);
};
